import { KycErrorType, KycOutcome, KycProviderName, TKycProviderOutput } from '../../../types/data';

// Spec's `initial` / `incomplete` → onCancel omitted: web SDK has no close event to reach them.
export enum SumsubStatus {
    APPROVED = 'approved',
    PENDING = 'pending',
    TEMPORARILY_DECLINED = 'temporarilyDeclined',
    FINALLY_REJECTED = 'finallyRejected',
    FAILED = 'failed',
}

// Mapping per KycProvider wiki → Outcomes → Sumsub.
export const SUMSUB_STATUS_OUTCOME: Record<SumsubStatus, TKycProviderOutput> = {
    [SumsubStatus.APPROVED]: { provider: KycProviderName.SUMSUB, outcome: KycOutcome.SUCCESS, errorType: null, providerStatus: null, inquiryId: null },
    [SumsubStatus.PENDING]: { provider: KycProviderName.SUMSUB, outcome: KycOutcome.SUCCESS, errorType: null, providerStatus: null, inquiryId: null },
    [SumsubStatus.TEMPORARILY_DECLINED]: {
        provider: KycProviderName.SUMSUB,
        outcome: KycOutcome.ERROR,
        errorType: KycErrorType.VERIFICATION_DECLINED,
        providerStatus: null,
        inquiryId: null,
    },
    [SumsubStatus.FINALLY_REJECTED]: {
        provider: KycProviderName.SUMSUB,
        outcome: KycOutcome.ERROR,
        errorType: KycErrorType.VERIFICATION_REJECTED,
        providerStatus: null,
        inquiryId: null,
    },
    [SumsubStatus.FAILED]: {
        provider: KycProviderName.SUMSUB,
        outcome: KycOutcome.ERROR,
        errorType: KycErrorType.PROVIDER_ERROR,
        providerStatus: SumsubStatus.FAILED,
        inquiryId: null,
    },
};
